import { render } from "./BaseTypePanel.vue?vue&type=template&id=18d85390"
import script from "./BaseTypePanel.vue?vue&type=script&lang=js"
export * from "./BaseTypePanel.vue?vue&type=script&lang=js"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__